import { ProductionCardBundle, ProductionCardBundleStatus } from '@app/models/production/production-card/production-card-bundle';

export class ProductionCardBundleStatusUtil {
  public static getValidNextStatuses(currentStatus: ProductionCardBundleStatus, bundle?: ProductionCardBundle): number[] {
    switch (currentStatus) {
      case ProductionCardBundleStatus.Processing:
        return [ProductionCardBundleStatus.ReadyForWeighing];

      case ProductionCardBundleStatus.ReadyForWeighing:
        // Allow returning to Processing only if not weighed
        if (!bundle?.actualWeightInLbs || bundle.actualWeightInLbs === 0) {
          return [ProductionCardBundleStatus.Processing];
        }
        return [];

      default:
        return [];
    }
  }

  public static canReturnToProcessing(bundle: ProductionCardBundle | null): boolean {
    if (!bundle) return false;
    return bundle.status === ProductionCardBundleStatus.ReadyForWeighing && (!bundle.actualWeightInLbs || bundle.actualWeightInLbs === 0);
  }

  public static isReadOnly(status: ProductionCardBundleStatus): boolean {
    return status !== ProductionCardBundleStatus.Processing;
  }
}
